import { KettleOutlineIcon } from './KettleOutlineIcon';

/**
 * author: Nick
 * id FCE0A2B1-414F-4E9F-AF73-F878AE890F38
 * name kettle-outline
 * version: 3.9.97
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/kettle-outline.svg
 * tags
 * - Food / Drink 
 * - Home Automation 
 */
export const KettleEmptyIcon = KettleOutlineIcon;
export default KettleEmptyIcon